import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/* Auto-generated. Do not edit! */
/* eslint-disable */

const SvgFacebookShare = props => /*#__PURE__*/_jsxs("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 49,
  height: 48,
  viewBox: "0 0 49 48",
  fill: "rgb(0 0 0 / 60%)",
  ...props,
  children: [/*#__PURE__*/_jsx("mask", {
    id: "a",
    width: 49,
    height: 48,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: 'luminance'
    },
    children: /*#__PURE__*/_jsx("path", {
      fill: "#fff",
      d: "M48.667 0h-48v48h48z"
    })
  }), /*#__PURE__*/_jsxs("g", {
    mask: "url(#a)",
    children: [/*#__PURE__*/_jsx("path", {
      fill: "#fff",
      d: "M24.667 48c13.255 0 24-10.745 24-24s-10.745-24-24-24-24 10.745-24 24 10.745 24 24 24"
    }), /*#__PURE__*/_jsx("path", {
      fill: "#1877F2",
      d: "M48.667 24.147C48.667 10.81 37.922 0 24.667 0s-24 10.81-24 24.147c0 12.052 8.776 22.042 20.25 23.853V31.127h-6.094v-6.98h6.094v-5.32c0-6.052 3.583-9.395 9.065-9.395 2.625 0 5.372.472 5.372.472v5.942h-3.026c-2.981 0-3.911 1.862-3.911 3.773v4.528h6.656l-1.064 6.98h-5.592V48c11.473-1.812 20.25-11.801 20.25-23.853"
    })]
  })]
});
export default SvgFacebookShare;